/*
  Все графы бланка домовой книги одного человека - макет Б «как в бланке»,
  выбранный владельцем 01.10.2026.

  Рождение, прибытие и выбытие стоят строкой «когда - где», как графы бланка
  «Когда и откуда прибыл», «Когда и куда выбыл»: человек сверяет поля с картинкой
  построчно. Ниже цель прибытия, паспорт и гражданство. С 06.10.2026
  распознавание читает бланк по графам и заполняет их все; прочитанное жёлтым -
  его человек сверяет с картинкой.

  Компонент только рисует: значения и правка приходят пропсами - для первого
  человека из основных полей страницы, для остальных из списка добавленных.
*/

import { Field } from '../Common.jsx'
import { FIELD_LIMITS, PAIRS, SINGLES } from './scanFields.js'

function inputClass(doubtful, name) {
  return doubtful.has(name) ? 'field__input scan__doubtful' : 'field__input'
}

// У каждого поля предел длины колонки сервера (`FIELD_LIMITS`, 01.10.2026).
export default function ScanPerson({ values, doubtful = new Set(), onEdit }) {
  const input = (name, label) => (
    <input
      className={inputClass(doubtful, name)}
      aria-label={label}
      maxLength={FIELD_LIMITS[name]}
      value={values[name] ?? ''}
      onChange={(event) => onEdit(name, event.target.value)}
    />
  )
  return (
    <div className="stack">
      <Field label="ФИО" className={doubtful.has('full_name') ? 'field--doubtful' : undefined}>
        <input
          className="field__input"
          maxLength={FIELD_LIMITS.full_name}
          value={values.full_name ?? ''}
          onChange={(event) => onEdit('full_name', event.target.value)}
        />
      </Field>
      <div className="scan__pairs">
        <span />
        <span className="scan__pair-head">когда</span>
        <span className="scan__pair-head">где, откуда, куда</span>
        {PAIRS.map(([title, when, where]) => (
          <div key={when} className="scan__pair">
            <span className="field__label scan__pair-title">{title}</span>
            {input(when, `${title}: когда`)}
            {input(where, `${title}: где`)}
          </div>
        ))}
      </div>
      {SINGLES.map(([name, title]) => (
        <Field key={name} label={title} className={doubtful.has(name) ? 'field--doubtful' : undefined}>
          <input
            className="field__input"
            maxLength={FIELD_LIMITS[name]}
            value={values[name] ?? ''}
            onChange={(event) => onEdit(name, event.target.value)}
          />
        </Field>
      ))}
    </div>
  )
}
